import { Button, DatePicker, Dropdown, Modal, Tabs, message } from 'antd';
import { DoubleLeftOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import withDashboardLayout from '../../../hoc/withDashboardLayout';
import Services from '../../../components/admin/serviceProviderDetails/Services';
import Gallery from '../../../components/admin/serviceProviderDetails/Gallery';
import Reviews from '../../../components/admin/serviceProviderDetails/Reviews';
import StarIcon from '../../../assets/star-icon.png';
import LocationIcon from '../../../assets/location-icon.png';
import GlobeIcon from '../../../assets/globe-icon.png';
import MailIcon from '../../../assets/mail-icon.png';
import SendIcon from '../../../assets/send-icon.png';
import ThreeDotsIcon from '../../../assets/threedots-icon.png';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { DeleteServiceProvider, GetServiceProviderById, GetServiceProviderRating, UpdateServiceProvider } from '../../../utils/api';
import Loader from '../../../components/shared/Loader';
import SendEmailNotification from '../../../components/admin/serviceProvider/SendEmailNotification';
import dayjs from 'dayjs';
import StarRound from "../../../assets/star-round.svg";
import { imgPath } from '../../../utils/axiosInstance';


const dropdownItems = [
    {
        label: 'Remove from Spotlight',
        key: 0,
    },
    {
        label: 'Add to Spotlight',
        key: 2,
    },
    {
        label: 'Delete',
        key: 'deleted',
    },
];

const ServiceProviderDetails = () => {
    const { state } = useLocation();
    const { RangePicker } = DatePicker;
    const { id } = useParams();
    const navigate = useNavigate();
    const [notificationDrawerData, setNotificationDrawerData] = useState({ visible: false, data: null });
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [serviceData, setServiceData] = useState(null);
    const [averageRating, setAverageRating] = useState(null);
    const [activeTab, setActiveTab] = useState('services');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [modalData, setModalData] = useState({ visible: false, action: null, value: null, data: null });

    const onRangeChange = (dates) => {
        if (dates === null) {
            setEndDate(null)
            setStartDate(null)
        }
        if (dates && dates.length === 2) {
            const startDate = dates[0].format('YYYY-MM-DD');
            const endDate = dates[1].format('YYYY-MM-DD');
            if (startDate) {
                setStartDate(startDate);
            }
            if (endDate) {
                setEndDate(endDate);
            }
        }
    };

    // const rangePresets = [
    //     {
    //         label: 'Last 7 Days',
    //         value: [dayjs().add(-7, 'd'), dayjs()],
    //     },
    //     {
    //         label: 'Last 14 Days',
    //         value: [dayjs().add(-14, 'd'), dayjs()],
    //     },
    //     {
    //         label: 'Last 30 Days',
    //         value: [dayjs().add(-30, 'd'), dayjs()],
    //     },
    //     {
    //         label: 'Last 90 Days',
    //         value: [dayjs().add(-90, 'd'), dayjs()],
    //     },
    // ];



    const items = [
        {
            key: 'services',
            label: `Services`,
            children: <Services startDate={startDate} endDate={endDate} />,
        },
        {
            key: 'gallery',
            label: `Gallery`,
            children: <Gallery activeTab={activeTab} startDate={startDate} endDate={endDate} />,
        },
    ];

    if (state?.type === 'onboarded') {
        items.push({
            key: 'reviews',
            label: `Reviews`,
            children: <Reviews id={id} startDate={startDate} endDate={endDate} activeTab={activeTab} />,
        });
    }

    const onTabChange = (key) => {
        setActiveTab(key);
        setStartDate(null);
        setEndDate(null);
    }

    const handleBack = () => {
        navigate('/admin/service-providers');
    }

    const getServiceById = async () => {
        setLoading(true);
        if (id) {
            try {
                const res = await GetServiceProviderById(id);
                if (res?.isSuccess) {
                    setServiceData(res?.data);
                    setLoading(false);
                } else {
                    setLoading(false);
                    message.error('Error while fetching detials, Please try again');
                }
            } catch (error) {
                setLoading(false);
            }
        } else {
            setLoading(true);
            message.error('Error while fetching detials, Please try again');
        }
    };



    const getAverageRating = async () => {
        setLoading(true);
        if (id) {
            try {
                const res = await GetServiceProviderRating({ businessProfileId: id });
                if (res?.isSuccess) {
                    setAverageRating(res?.message);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
            }
        } else {
            setLoading(true);
            message.error('Error while fetching details, Please try again');
        }
    };


    const handleActionModalOpen = (value, data) => {
        setModalData({ visible: true, action: value === 'deleted' ? 'delete' : 'spotlight', value: value, data: data });
    };

    const handleOk = async () => {
        if (modalData.action === 'delete') {
            try {
                setBtnLoading(true);
                const res = await DeleteServiceProvider({ statusType: modalData?.value }, id);
                setBtnLoading(false);
                if (res?.isSuccess) {
                    message.success('Service provider deleted successfully');
                    setModalData({ id: null, visible: false, selectedStatus: null, user: null, action: null });
                    navigate(-1);
                }
            } catch (error) {
                setBtnLoading(false);
                message.error('Error in deletion, Try again later');
            }
        } else if (modalData.action === 'spotlight') {
            try {
                setBtnLoading(true);
                const res = await UpdateServiceProvider({ is_featured: modalData?.value }, id);
                setBtnLoading(false);
                if (res?.isSuccess) {
                    message.success('Service provider spotlight status successfully');
                    setModalData({ id: null, visible: false, selectedStatus: null, user: null, action: null });
                    getServiceById();
                }
            } catch (error) {
                setBtnLoading(false);
                message.error('Error in Updation, Try again later');
            }
        }
    }


    const handleModalCancel = () => {
        setModalData({ visible: false, action: null, value: null, data: null });
    }


    useEffect(() => {
        if (id) {
            getServiceById();
            getAverageRating();
        }
    }, [id]);

    if (loading) {
        return <Loader />
    }

    return (
        <div className='w-full h-full'>
            <div className='w-[95%] mx-auto'>

                {/* Service Provider Details Header */}
                <div className='w-full py-4 gap-x-2 flex items-center back-icon'>
                    <span className='text-base ml-0.5 cursor-pointer' onClick={handleBack}>
                        <DoubleLeftOutlined />
                    </span>
                    <h2 className='font-semibold text-lg'>Service Provider Details</h2>
                </div>

                {/* Service Provider Details */}
                <div className='w-full min-h-[calc(100vh-110px)] flex flex-col gap-y-4 box-shadow rounded-t-2xl pt-5'>
                    <div className="border border-[#3761971A] rounded-lg mx-6 p-5 flex justify-between gap-x-8">
                        {/* Info */}
                        <div className='w-4/12'>
                            <div className='details'>
                                <div className='flex items-center gap-3'>
                                    <div className='relative'>
                                        <img src={`${imgPath}${serviceData?.image}`} alt={serviceData?.business_name} className='w-12 h-12 object-cover rounded-lg' />
                                        {
                                            serviceData?.isFeatured === 2 ?
                                                <img className='absolute -bottom-1 -right-1.5 w-4' src={StarRound} alt="star-round" /> : null
                                        }
                                    </div>
                                    <div className=''>
                                        <p className='text-sm font-medium'>{serviceData?.business_name}</p>
                                        <span className='text-xs text-[#12B500]'>{serviceData?.user_name}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='text-lightGray text-xs pt-2 flex flex-col gap-1'>
                                <div className='flex items-center gap-x-2'>
                                    <img src={LocationIcon} alt='location-icon' className='w-3 h-3' />
                                    <span>{serviceData?.business_location}</span>
                                </div>
                                <div className='flex items-center gap-x-2'>
                                    <img src={GlobeIcon} alt='location-icon' className='w-3 h-3' />
                                    <span>{serviceData?.booking_link}</span>
                                </div>
                                <div className='flex items-center gap-x-2'>
                                    <img src={MailIcon} alt='location-icon' className='w-3 h-3' />
                                    <span>{serviceData?.user?.email}</span>
                                </div>

                            </div>
                        </div>

                        {/* Card */}
                        <div className='w-5/12 bg-[#f5f2f3] pl-1 pr-5 py-8 border border-primary-700 rounded-xl flex items-center justify-center'>
                            <div className='flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2'>
                                <div className="flex items-center justify-center gap-x-1">
                                    <span className='text-2xl font-bold text-primary-900'>{averageRating || 0}</span>
                                    <img src={StarIcon} alt="star-icon" className='w-4 h-4' />
                                </div>
                                <span className='text-xs text-primary-900 font-medium'>Rating</span>
                            </div>
                            <div className='flex-1 text-center border-r border-primary-700 px-2 flex flex-col gap-y-2'>
                                <span className="text-2xl font-bold text-primary-900">{serviceData?.booking_counter || 0}</span>
                                <span className='text-xs text-primary-900 font-medium'>Book now clicks</span>
                            </div>
                            <div className='flex-1 text-center flex flex-col gap-y-2'>
                                <span className="text-2xl font-bold text-primary-900">{serviceData?.profile_view}</span>
                                <span className='text-xs text-primary-900 font-medium'>Profile Views</span>
                            </div>
                        </div>

                        {/* Select Range */}
                        <div className='w-3/12 flex flex-col items-end justify-between'>
                            <div className='flex gap-x-2 items-center justify-between'>
                                <div className={`bg-primary-300 
                                ${serviceData?.statusType === 'active' && state.type === 'requested'
                                        ? 'text-[red]'
                                        : serviceData?.statusType === 'active'
                                            ? 'text-[#54a43a]'
                                            : serviceData?.statusType === 'inactive'
                                                ? 'text-orange'
                                                : serviceData?.statusType === 'blocked'
                                                    ? 'text-[red]'
                                                    : ''
                                    } border flex items-center gap-x-1 py-1 px-2.5 text-sm rounded-md font-medium`}>
                                    <span className={`capitalize`}>
                                        {state?.type === 'requested' ? 'Requested' : serviceData?.statusType}
                                    </span>
                                    {/* <CaretDownFilled /> */}
                                </div>
                                <button className='w-5 h-5 flex-shrink-0 cursor-pointer' onClick={() => setNotificationDrawerData({ visible: true, data: serviceData })}>
                                    <img src={SendIcon} alt="send-icon" />
                                </button>
                                {state?.type === 'onboarded' && <button className='w-5 h-5 flex-shrink-0'>
                                    <Dropdown
                                        menu={{
                                            items: dropdownItems.filter(item => item.key !== serviceData?.isFeatured),
                                            onClick: (e) => handleActionModalOpen(e?.key, serviceData)
                                        }}
                                        trigger={['click']}>
                                        <img src={ThreeDotsIcon} alt="send-icon" />
                                    </Dropdown>
                                </button>}
                            </div>
                            {
                                activeTab !== 'services' &&
                                state?.type === 'onboarded' &&
                                <div className='flex items-center flex-col gap-y-2'>
                                    <span className='text-sm text-primary-900 font-medium'>Select Range</span>
                                    <RangePicker
                                        value={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
                                        onChange={onRangeChange}
                                        format='D MMM YY'
                                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                                    // presets={rangePresets}
                                    />
                                </div>
                            }

                        </div>
                    </div>

                    <SendEmailNotification notificationDrawerData={notificationDrawerData} setNotificationDrawerData={setNotificationDrawerData} />

                    {/* Tabs */}
                    <div className='w-full'>
                        <Tabs defaultActiveKey={activeTab} items={items} onChange={onTabChange} />
                    </div>

                    <Modal
                        centered
                        title={modalData.action === 'spotlight' ? 'Confirm Spotlight Status Change' : 'Confirm Delete'}
                        open={modalData.visible}
                        onCancel={handleModalCancel}
                        footer={<div>
                            <Button onClick={handleModalCancel}>Cancel</Button>
                            <Button type='primary' className='text-white' onClick={handleOk}>
                                Ok
                                {btnLoading && <span className='loader ml-2 align-middle mb-1'></span>}
                            </Button>
                        </div>}
                    >
                        {
                            modalData.action === 'spotlight' ? `Are you sure you want to change spotlight status of ${modalData.data?.business_name}?` : `Are you sure you want to delete ${modalData.data?.business_name}?`
                        }

                    </Modal>


                </div>
            </div>
        </div >
    )
}

export default withDashboardLayout(ServiceProviderDetails);